<template>
  <div>
    <h1 class="medium survey__begin__title">
      {{ resources.component.survey.begin.surveyBeginStart.title }}
    </h1>

    <video-player
      :videoSource="
        `https://static.teamculture.com.br/libras/low/Apresentação_1.mp4`
      "
    />

    <div class="row mt-2 mb-5">
      <div class="col">
        <b-button
          v-if="!survey.length"
          class="btn-block survey-begin flex"
          variant="secondary"
          :disabled="true"
        >
          <loading-state />
        </b-button>

        <b-button
          v-else
          @click="begin"
          class="btn-block survey-begin"
          variant="secondary"
          id="btn-survey-begin"
          ref="btnSurveyBegin"
          tabindex="1"
          :title="resources.general.buttons.startAccessibility"
        >
          {{ resources.general.buttons.start }}
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import VideoPlayer from '@/components/Survey/VideoPlayer.vue'

export default {
  components: {
    'loading-state': () => import('@/components/Shared/Loading.vue'),
    VideoPlayer,
  },
  computed: {
    ...mapGetters({
      survey: 'survey/survey',
      surveyPage: 'survey/surveyPage',
      resources: 'resources',
    }),
  },
  watch: {
    survey() {
      this.$nextTick(() => {
        this.$refs.btnSurveyBegin.focus()
      })
    },
  },
  methods: {
    begin() {
      this.$store.dispatch('survey/startSurvey')
      this.$router.push('/survey/steps')
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~@/styles/custom/colors';

h5 {
  padding-top: 1.5rem;

  @media (max-width: 767px) {
    padding-top: 0;
    font-size: 14px;
  }
}

.survey-begin {
  max-width: 380px;
  margin: 0 auto;

  &.flex {
    display: flex;
    justify-content: center;
    align-items: center;

    /deep/ .lds-ellipsis {
      transform: translateY(-14px);
    }
  }
}
</style>
